import { module } from 'modujs';
import { Swiper, Keyboard, Navigation, Autoplay } from 'swiper';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {

    }

    initSlider(args) {
        Swiper.use([Keyboard, Navigation, Autoplay]);

        this.$container = this.$('container')[0];
        this.$close = this.$('close')[0];
        this.arrowPrev = this.$('prev')[0];
        this.arrowNext = this.$('next')[0];

        let currentIndex = args * 1;

        this.carousel = new Swiper(this.$container, {
            speed: 0,
            loop: true,
            slidesPerGroup: 1,
            slidesPerView: 1,
            spaceBetween: 0,
            threshold: 3,
            centeredSlides: true,
            initialSlide: currentIndex,
            allowTouchMove: false,
            navigation: {
                prevEl: this.arrowPrev,
                nextEl: this.arrowNext
            },
            keyboard: {
                enabled: true,
                onlyInViewport: false,
            },
            on: {
                slideChange: (swiper) => {
                    this.call('updateLazy', null, 'Scroll');
                }
            }
        });

        this.el.classList.add('is-active');

        this.$close.addEventListener('click', () => {
            this.destroySlider()
        });

    }

    destroySlider() {
        if (this.carousel) this.carousel.destroy()
        this.el.classList.remove('is-active');
    }

    destroy() {
        if (this.carousel) this.carousel.destroy()
        this.el.classList.remove('is-active');
    }
}
